import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  return (
    <header className="bg-black/95 backdrop-blur-sm text-white fixed w-full top-0 z-50 border-b border-yellow-500/20">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-yellow-500 rounded-lg flex items-center justify-center">
              <i className="ri-road-map-line text-black text-xl"></i>
            </div>
            <div>
              <h1 className="text-xl font-black tracking-tight">
                Bollard Installation Essex
              </h1>
            </div>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <a href="/" className="hover:text-yellow-500 transition-colors cursor-pointer">Home</a>
            <a href="/#services" className="hover:text-yellow-500 transition-colors cursor-pointer">Services</a>
            <a href="/areas" className="hover:text-yellow-500 transition-colors cursor-pointer">Areas</a>
            <a href="/#about" className="hover:text-yellow-500 transition-colors cursor-pointer">About</a>
            <a href="/#contact" className="hover:text-yellow-500 transition-colors cursor-pointer">Contact</a>
          </nav>

          <div className="flex items-center space-x-4">
            <div className="hidden lg:flex items-center space-x-2 text-sm">
              <i className="ri-phone-line text-yellow-500"></i>
              <span>+44 7834 858178</span>
            </div>
            <a href="tel:+447834858178" className="bg-yellow-500 text-black px-4 py-2 rounded-lg font-semibold hover:bg-yellow-400 transition-colors whitespace-nowrap cursor-pointer">
              Free Quote
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
